var _style, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOwner = function SvgOwner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "owner_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".owner_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "owner_svg__st0",
    d: "M20 21v-2c0-1.1-.4-2.1-1.2-2.8-.7-.8-1.7-1.2-2.8-1.2H8c-1.1 0-2.1.4-2.8 1.2-.8.7-1.2 1.7-1.2 2.8v2h16zM12 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4z"
  })));
};

export default SvgOwner;